import { GLOBAL_AGENTS_SID } from "@app/types/assistant/assistant";
import { CLAUDE_SONNET_5_5_DEFAULT_MODEL_CONFIG } from "@app/types/assistant/models/anthropic";
import {
  GPT_6_LUNA_MODEL_CONFIG,
  GPT_6_SOL_MODEL_CONFIG,
} from "@app/types/assistant/models/openai";
import type { ModelSelectionType } from "@app/types/assistant/models/types";

export const brandName = "Memoair";

export const brandAgentHandle = "friday";

// The one AgentMail inbox every chief of staff mails from; the display name
// is set per send, so each person sees their own agent's name on it.
export const brandAgentInboxLocalPart = "cos";

export const brandMarkUrl = "/static/brand/memoair-mark.png";

// The per-human chief of staff. Machine identity stays the inherited global
// agent sId; only the handle above is rebranded.
export const brandCosAgentId: string = GLOBAL_AGENTS_SID.DUST;

// The Pod's default responder. One agent, one principal per workspace; which
// Pod it is acting for comes from the conversation, the way `brandCosAgentId`
// takes its human from the authenticator.
export const brandPodAgentHandle = "pod";

export const brandPodAgentId: string = GLOBAL_AGENTS_SID.POD;

// Default for the chief of staff, the Pod agent and the composer when enabled;
// otherwise the first enabled selectable model. Agent-builder model
// configuration stays behind its existing gate.
export const brandDefaultModelConfig = CLAUDE_SONNET_5_5_DEFAULT_MODEL_CONFIG;

// The brand default per available provider, in preference order: Sonnet 5.5 when
// the Anthropic key is configured, GPT-6 Luna when only the OpenAI one is.
export const brandDefaultModelConfigs = [
  brandDefaultModelConfig,
  GPT_6_LUNA_MODEL_CONFIG,
];

export const brandDefaultModelReasoningEffort = "light" as const;

// Every routine run (scheduled, webhook and meeting) posts with this model, so
// the work it does on its own, Gmail drafts included, runs on GPT-6 Sol while
// chat stays on the brand default. A workspace without it falls back to the
// agent's own model through `resolveModel`.
export const brandRoutineRunModelSelection: ModelSelectionType = {
  providerId: GPT_6_SOL_MODEL_CONFIG.providerId,
  modelId: GPT_6_SOL_MODEL_CONFIG.modelId,
};

export const brandEmailSubjectPrefix = `[${brandName}]`;

export function brandPageTitle(page?: string | null): string {
  return page ? `${brandName} - ${page}` : brandName;
}
